export const en_general = {
  saveTxt: 'Save',
  editTxt: 'Edit',
  uploadAttachments: 'Upload Attachments',
  //Company Menu And Sub Menu Items
  generalTxt: 'General',
  analyticsInsights: 'Analytics Insights',
  detailView: 'Detail View',
  menuItem1: 'Basic Details',
  menuItem2: 'Contact Information',
  menuItem3: 'Lead Emails',
  menuItem4: 'Hours/ Call Connect',
  menuItem5: 'Users',
  menuItem12: 'Voice',
  menuItem13: 'Appointment',
  budgetTxt: 'Budget',
  menuItem6: 'Pacing, Leads and Traffic',
  menuItem11: 'History',
  settingTxt: 'Settings',
  menuItem7: 'Mobile',
  integrationTxt: 'Integrations',
  menuItem8: 'CRM',
  menuItem9: 'Facebook',
  menuItem10: 'Tracking',
  widget: 'Widget',
  appearance: 'Appearance',
  integrateWidget: 'Integrate Widget',
  userManagment: 'User Management',
  addUser: 'Add User',
  teamMembers: 'Team Members',
  activeText: 'Active',
  inActiveText: 'Inactive',
  goToOnboarding: 'Go to Onboarding',
  provisioningNote:
    'To make changes to this data, please go to the legacy portal.',
  provisioningErrorMsg:
    'There are some errors in the form. Please fix them before submitting.',
  portallang: 'Portal Language',
  profile: 'Profile',
  changePass: 'Change Password',
  logout: 'Logout',
  changeCompany: 'Change Company',
  messagingTag: 'To view the messaging portal',
  oldPortalTag:
    'For full functionality, visit the legacy portal for onboarding.',
  clickBtn: 'Click here',
  portalBtn: 'Legacy Portal'
};
export default en_general;
export { default as fr_general } from '../fr-FR-Dictionary/fr-general';
export { default as sp_general } from '../sp-SP-Dictionary/sp-general';
